import { render } from "./ClassMessages.vue?vue&type=template&id=6e593289&scoped=true"
import script from "./ClassMessages.vue?vue&type=script&lang=js"
export * from "./ClassMessages.vue?vue&type=script&lang=js"

import "./ClassMessages.vue?vue&type=style&index=0&id=6e593289&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e593289"]])

export default __exports__